import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

interface IStackedColumnsProps {
  series: { name: string; data: number[] }[];
  categories: string[];
  colors?: string[];
  width?: number;
}

const StackedColumns: React.FC<IStackedColumnsProps> = ({
  series,
  categories,
  colors,
  width,
}: IStackedColumnsProps) => {
  const options: ApexOptions = {
    colors,
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 10,
      },
    },
    xaxis: {
      categories,
    },
    legend: {
      position: 'right',
      offsetY: 40,
    },
    fill: {
      opacity: 1,
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="bar"
      width={width}
      height={480}
    />
  );
};

export default StackedColumns;
